<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span v-if="src" v-html="src"></span>
</template>
<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'RawIcon',
  inheritAttrs: false,
  props: {
    // file name
    icon: {
      type: String,
      required: true,
    },
    // svg'ye gonderilecek class="" değeri
    svgClass: {
      type: String,
      required: false,
    },
    // svg'ye gonderilecek style="" değeri
    svgStyle: {
      type: String,
      required: false,
    },
  },

  setup(props, { attrs }) {
    const src = computed(() => {
      let icon;
      try {
        icon = require(`assets/svg/${props.icon}.svg?raw`);
      } catch {
        console.error(`Can't find icon assets/svg/${props.icon}.svg`);
      }

      const inlineAttrs = Object.entries(attrs).reduce((acc, [key, value]) => {
        acc += `${key}="${value}" `;
        return acc;
      }, '');

      const svgStyleAttr = props.svgStyle ? `style="${props.svgStyle}"` : '';
      const svgClassAttr = props.svgClass ? `class="${props.svgClass}"` : '';
      icon = icon?.replace('<svg', `<svg ${svgStyleAttr} ${svgClassAttr} ${inlineAttrs} `);
      return icon;
    });
    return { src };
  },
});
</script>
